import Service from "../Service";

const resource = "ContainerInventory/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    getStock(cmtID, locationID, requestID) {
        return Service.get(resource + "stock", {
            params: { cmtID: cmtID, locationID: locationID, requestID: requestID },
        });
    },
    paginationDetail(parameters, cinID, requestID) {
        return Service.post(resource + "detail/pagination", parameters, {
            params: { cinID: cinID, requestID: requestID },
        });
    },
    saveDetail(obj, requestID) {
        return Service.post(resource + "detail/save", obj, {
            params: { requestID: requestID },
        });
    }
};
